import { TextLevelEnum as e } from "../extensions/heading-extension/text-level-enum.mjs";
import { ListEnum as t } from "../extensions/list-extension/list-enum.mjs";
import { TextAlignEnum as n } from "../extensions/text-align-extension/text-align-enum.mjs";
import { TextFormatEnum as r } from "../extensions/text-format-extension/text-format-enum.mjs";
import { getOS as i } from "./get-os.mjs";
//#region src/utils/get-shortcuts.ts
var a = {
	[r.Bold]: { toggle: "Mod-B" },
	[r.Italic]: { toggle: "Mod-I" },
	[r.Strike]: { toggle: "Mod-Shift-S" },
	[r.Underline]: { toggle: "Mod-U" },
	textAlign: {
		[n.Left]: "Mod-Shift-L",
		[n.Center]: "Mod-Shift-E",
		[n.Right]: "Mod-Shift-R",
		[n.Justify]: "Mod-Shift-J"
	},
	list: {
		[t.OrderedList]: "Mod-Shift-7",
		[t.BulletList]: "Mod-Shift-8"
	},
	heading: {
		[e.Default]: "Mod-Alt-0",
		[e.H2]: "Mod-Alt-2",
		[e.H3]: "Mod-Alt-3",
		[e.H4]: "Mod-Alt-4"
	},
	history: {
		undo: "Mod-Z",
		redo: "Shift-Mod-Z"
	}
}, o = (e) => {
	let t = i();
	return e.replace("Mod", t === "macOS" ? "⌘" : "Ctrl").replace("Alt", t === "macOS" ? "⌥" : "Alt").replace("-", " ");
};
//#endregion
export { o as getShortcut, a as rawShortcuts };
